import * as RadPopover from '@radix-ui/react-popover'
import { useState } from 'react'
import styled from 'styled-components'

import { useTranslation } from '@root/shared/localization'
import { ArchiveIcon } from '@root/shared/ui-kit'

import { PremiumArchivedList } from './premium-archived-list'

import type { PremiumArchivedListProps } from './premium-archived-list'
import type { PremiumId } from '../../model'
import type { ClassNameProps } from '@root/shared/react'

type Props = PremiumArchivedListProps & ClassNameProps

export const PremiumArchivedButton = (props: Props) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  const handleSelect = (id: PremiumId) => {
    props.onClick(id)
    setOpen(false)
  }

  return (
    <RadPopover.Root open={open} onOpenChange={setOpen}>
      <RadPopover.Trigger asChild>
        <Button className={props.className} type="button">
          <ArchiveIcon size={12} /> {t('premium.archived-list.archive')}
        </Button>
      </RadPopover.Trigger>
      <RadPopover.Portal>
        <Content side="bottom" align="end">
          <PremiumArchivedList
            items={props.items}
            onClick={handleSelect}
            current={props.current}
          />
        </Content>
      </RadPopover.Portal>
    </RadPopover.Root>
  )
}

const Content = styled(RadPopover.Content)``

const Button = styled.button`
  /* all: unset; */
  border: none;
  padding: 4px;
  display: flex;
  gap: 3px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 6px;
  color: var(--textA-11);
  background: var(--appearanceA-4, var(--appearanceA-4));

  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  backdrop-filter: blur(3px);

  &:hover {
    color: var(--textA-12);
  }
`
